export const environment = {
  production: false,
  yuloadApiUrl: 'https://yuload.data.yurest.dev',
  yuliaApiUrl: 'https://yulia.data.yurest.dev',
  baseUrlAsst: 'https://yulia.data.yurest.dev/v1/', // Assistant API base URL
  appVersion: '3.0.0',
};
